import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class ToCollegeToolConditionConfirm extends Component {
  render() {
    const {
      visible,
      close,
      subjectCondition,
      wholeSubject,
      time,
      handleConfirm,
      subjectScore,
      totalScore,
      times,
      release,
    } = this.props;
    return (
      <div
        className={
          visible === true
            ? "toCollegeTool_condition_confirm_box"
            : "toCollegeTool_condition_confirm_box  display_none"
        }
      >
        <div className="toCollegeTool_condition_confirm_inline_box">
          <div
            onClick={() => close()}
            className="toCollegeTool_condition_confirm_close"
          >
            <img
              alt=""
              src={require("../../../../../images/user/close.png")}
            ></img>
          </div>
          <div className="toCollegeTool_condition_confirm_subject">
            <span className="fl">选考科目：</span>
            <span className="fl">{wholeSubject[subjectCondition[0]]}</span>
            <span className="fl major_left_5">
              {wholeSubject[subjectCondition[1]]}
            </span>
            <span className="fl major_left_5">
              {wholeSubject[subjectCondition[2]]}
            </span>
          </div>

          <div className="toCollegeTool_condition_confirm_score">
            <div className="fl">各科分数：</div>
            <br />
            <div className="clear"></div>
            <div className="fl major_top_10">
              <span>语文:</span>
              <span className="color_fe5900 major_left_10">
                {subjectScore["语文"]}
              </span>
              <span className="major_left_20">数学: </span>
              <span className="color_fe5900 major_left_10">
                {subjectScore["数学"]}
              </span>
            </div>
            <br />
            <div className="fl major_top_10">
              <span>外语:</span>
              <span className="color_fe5900 major_left_10">
                {subjectScore["外语"]}
              </span>
              <span className="major_left_20">
                {wholeSubject[subjectCondition[0]]}:{" "}
              </span>
              <span className="color_fe5900 major_left_10">
                {subjectScore[wholeSubject[subjectCondition[0]]]}
              </span>
            </div>
            <br />
            <div className="fl major_top_10">
              <span>{wholeSubject[subjectCondition[1]]}:</span>
              <span className="color_fe5900 major_left_10">
                {subjectScore[wholeSubject[subjectCondition[1]]]}
              </span>
              <span className="major_left_20">
                {wholeSubject[subjectCondition[2]]}:{" "}
              </span>
              <span className="color_fe5900 major_left_10">
                {subjectScore[wholeSubject[subjectCondition[2]]]}
              </span>
            </div>
            <br />
            <div className="clear"></div>
            <div className="fl major_top_10 ">
              <span>总分:</span>
              <span className="color_fe5900 major_left_10">{totalScore}</span>
            </div>
          </div>
          <div className="clear"></div>
          <div className="toCollegeTool_condition_confirm_info">
            {release === 0 ? (
              <div>
                *&nbsp;&nbsp;出分前以上信息，每周可改，本周还有{times}
                次，出分后修改1次，借用将不能改回。{" "}
              </div>
            ) : (
              <div>
                需考生本人成绩，以上信息确认后将不能再修改，借用将不能改回。
              </div>
            )}
          </div>
          <div style={{ width: "208px", margin: "0 auto" }}>
            <div
              onClick={() => handleConfirm()}
              className={
                time > 0
                  ? "toCollegeTool_condition_confirm_disabled_btn fl"
                  : "toCollegeTool_condition_confirm_btn fl"
              }
            >
              {time > 0 ? time : "确 认"}
            </div>
            <div
              onClick={() => close()}
              className="toCollegeTool_condition_confirm_btn fr"
            >
              取消
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ToCollegeToolConditionConfirm;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolCondition/components/ToCollegeToolConditionConfirm/index.js